import * as React from 'react';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { UniversalNavigationBar } from '../UniversalNavigationBar.tsx';
import { EAdminPages } from '../../../../../common/interfaces/admin';
import { toPath } from '../../../../../common/helpers/toPath';
import { IAppOnlyStore } from '../../../stores';

// Styles
const s = require('./AdminNavigationBar.css');

// Component
@inject('store')
@observer
export class AdminNavigationBar extends React.Component<IAppOnlyStore, {}> {
    render() {
        return (
            <UniversalNavigationBar
                links={Object.keys(EAdminPages).map(page => {
                    const pageTitle = EAdminPages[page];
                    return {
                        key: toPath(pageTitle),
                        title: pageTitle,
                        active: this.props.store.admin.page === pageTitle,
                        onClick: this.handleLinkClick(pageTitle)
                    };
                })}
            />
        );
    }

    @action
    private handleLinkClick = (page: EAdminPages) => (e: React.MouseEvent<HTMLAnchorElement>) => {
        this.props.store.admin.changePage(page);
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/AdminNavigationBar/AdminNavigationBar.tsx